var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordedButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.924,
    height: 45.924,
    viewBox: "0 0 45.924 45.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18650",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18650",
    transform: "translate(-512.83 -394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_5680",
    "data-name": "\\u6955\\u5186\\u5F62 5680",
    transform: "translate(512.83 394)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.962,
    cy: 22.962,
    r: 22.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.962,
    cy: 22.962,
    r: 22.462,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Video",
    transform: "translate(524.354 403.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28058",
    "data-name": "\\u30D1\\u30B9 28058",
    d: "M13.86,18.569H3.581A1.581,1.581,0,0,1,2,16.988V9.081A1.581,1.581,0,0,1,3.581,7.5H13.86a1.581,1.581,0,0,1,1.581,1.581v7.907A1.581,1.581,0,0,1,13.86,18.569Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28059",
    "data-name": "\\u30D1\\u30B9 28059",
    d: "M21,10.845v4.744l3.515,2.344a.791.791,0,0,0,1.229-.659V9.16A.791.791,0,0,0,24.515,8.5Z",
    transform: "translate(-3.977 -0.182)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordedButton);
export default __webpack_public_path__ + "static/media/recordedButton.9b59cf684515feb0f12b0f1b7fb042e8.svg";
export { ForwardRef as ReactComponent };